<template>
    <div class="r-column fr bgw mht-400">
        <Crumb :typeId="typeId"></Crumb>
        <div v-if="!count" class="tcenter tc9 fs18 no-cont">
            <div :class="isLoad ? 'icon-jiazaizhong' : 'icon-kongneirong'" 
                class="iconfont"></div>
            {{isLoad ? '稍等，数据加载中' : '抱歉，没有相关内容'}}
        </div>
        <NoticeList v-else :newsList="newsList" :page="page" :pageSize="pageSize" :showPage="true" />
        <Page v-if="count" :pageNum="page + 1" :pageSize="pageSize" :count="count" @chagePage="chagePage" />
    </div>
</template>
<script>
import Crumb from '@/components/common/Crumb'
import NoticeList from '@/components/notice/NoticeList'
import Page from '@/components/common/MyPagination'
import { throws } from 'assert'
export default {
    data() {
        return {
            newsList: [],
            typeId: 0,
            page: 0,
            pageSize: 15,
            count: 0,
            isFirst: true,
            isLoad: false
        }
    },
    components: {
        Crumb,
        NoticeList,
        Page
    },
    created() {
        this.initData()
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                if (nV.params.id != oV.params.id) {
                    this.count = 0
                    this.page = 0
                    this.initData()
                }
            }
        }
    },
    methods: {
        initData() {
            this.typeId = this.$route.params.id
            this.getNewsList()
        },
        getNewsList() {
            this.isLoad = true
            const query = {
                category_id: this.typeId,
                page: this.page + 1,
                perPage: this.pageSize
            }
            this.$request.get('article/list', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    this.newsList = data.data
                    this.count = parseInt(data.total)
                    //console.log(this.newsList)
                }
                this.isLoad = false
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        }

    }
}
</script>
<style scope>
    .no-cont {
        margin-top: 80px;
    }
    .iconfont.icon-jiazaizhong{
        margin-bottom: 20px;
        font-size: 60px;
        color: #333;
    }
</style>
